export enum SymptomDetailControlCodes {
  STATISTICS = 'symptom_statistic',
  OVERVIEW = 'symptom_description',
  ARTICLES = 'symptom_articles',
  RECOMMENDATIONS = 'symptom_recommendations',
  TAGS = 'symptom_tags',
  NUTRITION_ITEMS = 'symptom_nutrition',
}
